/** @file Runs a structural edit and refuses it (CYCLE) when it closes an IK dependency loop (§6.6). */
import type { Doc } from '@pose2d/format/types';
import { ikCycles } from '@pose2d/format/doc/ikCycles';
import { throwError } from '@pose2d/format/throwError';

/**
 * Runs `edit` on `draft`, then throws CYCLE at `at` when the edit closed an IK dependency loop: constraints that each
 * read a bone another one moves, round (validateDoc's checkDocIk rule; compileDoc could not order them). params.path
 * and the hint name the constraints. A document that already held a loop is left to validateDoc, so a command that
 * repairs one of several loops still applies.
 */
export function editWithoutIkCycle(draft: Doc, at: string, edit: () => void): void {
  const before = ikCycles(draft).length;
  edit();
  if (before > 0) return;
  const [loop] = ikCycles(draft);
  if (loop === undefined) return;
  const names = [...loop, loop[0] ?? ''].map((id) => draft.constraints[id]?.name ?? id).join(' -> ');
  throwError('CYCLE', { path: names }, { path: at, hint: `each of these IK constraints would move a bone another one reads, so no update order exists: ${names}` });
}
